import { render, staticRenderFns } from "./StationNavigation.vue?vue&type=template&id=0608448f&scoped=true"
import script from "./StationNavigation.vue?vue&type=script&lang=js"
export * from "./StationNavigation.vue?vue&type=script&lang=js"
import style0 from "./StationNavigation.vue?vue&type=style&index=0&id=0608448f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0608448f",
  null
  
)

export default component.exports